module.exports = __webpack_public_path__ + "static/media/favorite.291f405a.svg";